import { SelectOptionType } from '@octano/global-ui';

import { actionKitImpFunction } from '../../../../components/ozmoit/common';
import { baseToSelectOption } from '../../../academicOffers/courses/utils';
import {
  ActivityType,
  ProgramUnitSubject,
  Course,
  getFormDataRequest,
  getCourseFormDataRequest,
  getProgramFormDataRequest,
  getStudyPlansListRequest,
  StudyPlanListResponse,
} from '../api';

export interface StudyPlansListParams {
  page: number;
  items_per_page: number;
  name?: string;
  code?: string;
  schoolId?: number;
  modalityId?: number;
  campusId?: number;
}

interface FormDataActionReturn {
  schools: SelectOptionType[];
  campuses: SelectOptionType[];
  modalities: SelectOptionType[];
}

interface CourseFormDataActionReturn {
  courses: Course[];
  activityTypes: ActivityType[];
}

interface ProgramFormDataActionReturn {
  schools: SelectOptionType[];
  modalities: SelectOptionType[];
  activityTypes: ActivityType[];
  subjects: ProgramUnitSubject[];
}

const getFormDataAction = actionKitImpFunction(
  async (): Promise<FormDataActionReturn> => {
    const response = await getFormDataRequest();
    if (response.error) {
      throw new Error('Error fetching form data');
    }

    const { data } = response;

    return {
      schools: baseToSelectOption(data?.schools),
      campuses: baseToSelectOption(data?.campuses),
      modalities: baseToSelectOption(data?.modalities),
    };
  },
);

const getCourseFormDataAction = actionKitImpFunction(
  async (): Promise<CourseFormDataActionReturn> => {
    const response = await getCourseFormDataRequest();
    if (response.error) {
      throw new Error('Error fetching course form data');
    }

    const { data } = response;

    return {
      courses: data?.courses || [],
      activityTypes: data?.activityTypes || [],
    };
  },
);

const getProgramFormDataAction = actionKitImpFunction(
  async (): Promise<ProgramFormDataActionReturn> => {
    const response = await getProgramFormDataRequest();
    if (response.error) {
      throw new Error('Error fetching program form data');
    }

    const { data } = response;

    return {
      schools: baseToSelectOption(data?.schools),
      modalities: baseToSelectOption(data?.modalities),
      activityTypes: data?.activityTypes || [],
      subjects: data?.subjects || [],
    };
  },
);

const getStudyPlansListAction = actionKitImpFunction(
  async (params: StudyPlansListParams): Promise<StudyPlanListResponse> => {
    const { page, items_per_page, ...filters } = params;
    const response = await getStudyPlansListRequest(
      filters,
      page,
      items_per_page,
    );
    if (response.error) {
      throw new Error('Error fetching study plans list');
    }
    return response.data!;
  },
);

export {
  getFormDataAction,
  getCourseFormDataAction,
  getProgramFormDataAction,
  getStudyPlansListAction,
};
export type {
  FormDataActionReturn,
  CourseFormDataActionReturn,
  ProgramFormDataActionReturn,
};
